module.exports = __webpack_public_path__ + "img/vfd.f52a4039.jpg";